import React, { lazy } from 'react';
import { RouteConfig } from '../../types';

const PriorAuthSummary = lazy(() =>
  import('@src/apps/PriorAuth/PriorAuthComponent').then((m) => ({ default: m.PriorAuthComponent }))
);
const PriorAuthCptApprovel = lazy(() =>
  import('@src/apps/PriorAuth/CPTApprovels/PriorAuthCptApprovelComponent').then((m) => ({
    default: m.PriorCPTApprovalsComponent,
  }))
);
const PriorAuthNotApproved = lazy(() =>
  import('@src/apps/PriorAuth/PANotApproved/PriorAuthNotApprovedComponent').then((m) => ({
    default: m.PriorAuthNotApprovedComponent,
  }))
);
// GoldCardLoader replicates Angular's gold-card-landing.component.ts ngOnInit gate:
// it calls the provTinListFilter API (or reads existing sessionStorage keys for
// external/simulation flows), populates tinsListGC / selectedTaxId / selectedTinName,
// and only then renders the GoldCard component — exactly like Angular's *ngIf="gcParcelLoad".
const GoldCardLoader = lazy(() => import('@src/apps/GoldCard/GoldCardLoader'));

const priorAuthRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  padding: '0px',
  boxSizing: 'border-box',
};

const PriorAuthRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={priorAuthRouteFrameStyles}>{children}</div>
);

const GoldCardRoute = () => (
  <PriorAuthRouteFrame>
    <GoldCardLoader />
  </PriorAuthRouteFrame>
);

const PriorAuthCptApprovelRoute = () => (
  <PriorAuthRouteFrame>
    <PriorAuthCptApprovel />
  </PriorAuthRouteFrame>
);

const PriorAuthNotApprovedRoute = () => (
  <PriorAuthRouteFrame>
    <PriorAuthNotApproved />
  </PriorAuthRouteFrame>
);

export const priorAuthRoutes: RouteConfig[] = [
  {
    path: 'prior-auth',
    component: PriorAuthSummary,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Prior Auth',
      breadcrumb: 'Prior Auth',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'prior-auth/pa-cpt-codes',
    component: PriorAuthCptApprovelRoute,
    guards: ['auth', 'vendor'],
    data: {
      title: 'PA CPT Codes',
      breadcrumb: 'PA CPT Codes',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'prior-auth/pa-not-approved',
    component: PriorAuthNotApprovedRoute,
    guards: ['auth', 'vendor'],
    data: {
      title: 'PA Not Approved',
      breadcrumb: 'PA Not Approved',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'prior-auth/gold-card',
    component: GoldCardRoute,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Gold Card',
      breadcrumb: 'Gold Card',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'prior-auth/summary-angular',
    component: PriorAuthSummary,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Prior Auth Summary',
      breadcrumb: 'Summary',
      preload: false,
      delay: true,
    },
  },
];
